<template>
  <!-- Main Layout Components -->
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb Section -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <!-- Action Controls Section -->
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <!-- List/Grid View Toggle -->
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <!-- List View Button -->
              <router-link
                to="/projects/projects-list"
                class="btn btn-icon btn-sm me-1"
              >
                <i class="ti ti-list-tree"></i>
              </router-link>
              <!-- Grid View Button (Active) -->
              <router-link
                to="/projects/projects-grid"
                class="btn btn-icon btn-sm active bg-primary text-white"
              >
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div>

          <!-- Search Input -->
          <div class="me-3 mb-2">
            <input
              v-model="store.filters.q"
              @input="debouncedReload"
              type="text"
              class="form-control"
              placeholder="Search projects..."
            />
          </div>

          <!-- Priority Filter Dropdown -->
          <div class="dropdown me-2 mb-2">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              Select Priority
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a class="dropdown-item rounded-1" @click="setPriority('')"
                  >All</a
                >
              </li>
              <li>
                <a class="dropdown-item rounded-1" @click="setPriority('High')">
                  High
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  @click="setPriority('Medium')"
                >
                  Medium
                </a>
              </li>
              <li>
                <a class="dropdown-item rounded-1" @click="setPriority('Low')">
                  Low
                </a>
              </li>
            </ul>
          </div>

          <!-- Export Dropdown -->
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportAs('pdf')"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportAs('xlsx')"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Add Project Button -->
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_project"
              class="btn btn-primary d-flex align-items-center"
              @click="openCreate"
              v-can="'Project.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Project
            </a>
          </div>

          <!-- Header Collapse Toggle -->
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- End Breadcrumb -->

      <!-- Filters Card -->
      <div class="card">
        <div class="card-body p-3">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
          >
            <h5>Projects Grid</h5>

            <!-- Secondary Filters -->
            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <!-- Status Filter -->
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Status: {{ statusLabel }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setStatus('')"
                    >
                      All
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setStatus('Active')"
                    >
                      Active
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setStatus('Inactive')"
                    >
                      Inactive
                    </a>
                  </li>
                </ul>
              </div>

              <!-- Sort & Date Range Dropdown -->
              <div class="dropdown">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Sort By : {{ sortDisplay }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <!-- Sort Options -->
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="applySort('recent')"
                    >
                      Recently Added
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="applySort('asc')"
                    >
                      Ascending
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="applySort('desc')"
                    >
                      Descending
                    </a>
                  </li>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <!-- Date Range Options -->
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="applyLastMonth"
                    >
                      Last Month
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="applyLast7Days"
                    >
                      Last 7 Days
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Loading Indicator -->
          <div v-if="store.loading" class="mt-2">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Loading projects...
          </div>
        </div>
      </div>

      <!-- Project Grid Cards -->
      <div class="row">
        <!-- Empty State -->
        <div v-if="!store.loading && !projects.length" class="col-12">
          <div class="card">
            <div class="card-body text-center py-5">
              <p class="mb-2">No projects found.</p>
              <!-- <p class="text-muted mb-3">
                Try changing filters or add a new project.
              </p> -->
              <button
                class="btn btn-primary"
                @click="openCreate"
                v-can="'Project.Create'"
              >
                <i class="ti ti-circle-plus me-2"></i>Add Project
              </button>
            </div>
          </div>
        </div>

        <!-- Project Cards -->
        <div
          v-for="proj in projects"
          :key="proj.id"
          class="col-xxl-3 col-lg-4 col-md-6"
        >
          <div class="card h-100">
            <div class="card-body d-flex flex-column">
              <!-- Card Header: Title + Action Menu -->
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <h6 class="mb-0 text-truncate">
                  <router-link
                    :to="`/projects/projects-details/${proj.id}`"
                    class="text-dark"
                  >
                    {{ proj.name }}
                  </router-link>
                </h6>

                <!-- Action Dropdown -->
                <div class="dropdown">
                  <a
                    href="javascript:void(0);"
                    class="d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-dots-vertical"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item rounded-1"
                        @click.prevent="onView(proj)"
                      >
                        <i class="ti ti-eye me-2"></i>Quick View
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item rounded-1"
                        @click.prevent="onEdit(proj)"
                      >
                        <i class="ti ti-edit me-2"></i>Edit
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item rounded-1"
                        @click.prevent="onDelete(proj)"
                      >
                        <i class="ti ti-trash me-1"></i>Delete
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Project Description -->
              <div class="mb-3 pb-3 border-bottom">
                <p class="mb-0 text-muted line-clamp-3">
                  {{ proj.description_plain || "No description provided." }}
                </p>
              </div>

              <!-- Project Leader & Deadline -->
              <div
                class="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom"
              >
                <div class="d-flex align-items-center file-name-icon">
                  <span
                    class="avatar avatar-sm avatar-rounded flex-shrink-0 border"
                  >
                    <img
                      v-if="proj.leader_avatar"
                      :src="proj.leader_avatar"
                      class="img-fluid"
                      alt="leader"
                    />
                    <img
                      v-else
                      :src="require(`@/assets/img/users/user-01.jpg`)"
                      class="img-fluid"
                      alt="leader"
                    />
                  </span>
                  <div class="ms-2">
                    <h6 class="fw-normal fs-12 mb-0">
                      <a href="javascript:void(0);">
                        {{ proj.leader_name || "Unassigned" }}
                      </a>
                    </h6>
                    <span class="fs-12 fw-normal text-muted"
                      >Project Leader</span
                    >
                  </div>
                </div>

                <div class="text-end">
                  <span class="fs-12 fw-normal d-block text-muted"
                    >Deadline</span
                  >
                  <p class="mb-0 fs-12">
                    {{ formatDateFancy(proj.deadline || proj.end_date) }}
                  </p>
                </div>
              </div>

              <!-- Tasks & Team Members -->
              <div
                class="d-flex align-items-center justify-content-between mb-3"
              >
                <!-- Tasks Completion -->
                <div class="d-flex align-items-center">
                  <span
                    class="avatar avatar-sm avatar-rounded bg-success-transparent flex-shrink-0 me-2"
                  >
                    <i class="ti ti-checklist text-success fs-16"></i>
                  </span>
                  <p class="mb-0 fs-12">
                    <small class="text-muted">Tasks :</small>
                    <span class="text-dark fw-medium">
                      <template
                        v-if="
                          proj.completed_tasks != null &&
                          proj.total_tasks != null
                        "
                      >
                        {{ proj.completed_tasks }}</template
                      ><template v-else> — </template>
                    </span>
                    <template v-if="proj.total_tasks != null">
                      /{{ proj.total_tasks }}
                    </template>
                  </p>
                </div>

                <!-- Team Avatars -->
                <div class="avatar-list-stacked avatar-group-sm">
                  <span
                    v-for="(av, i) in (proj.team_avatars || []).slice(0, 3)"
                    :key="i"
                    class="avatar avatar-rounded"
                  >
                    <img
                      class="border border-white"
                      :src="
                        av || require(`@/assets/img/profiles/avatar-02.jpg`)
                      "
                      alt="img"
                    />
                  </span>
                  <a
                    v-if="(proj.extra_team_count || 0) > 0"
                    class="avatar bg-primary avatar-rounded text-fixed-white fs-12 fw-medium"
                    href="javascript:void(0);"
                  >
                    +{{ proj.extra_team_count }}
                  </a>
                </div>
              </div>

              <!-- Card Footer: Priority & Status -->
              <div
                class="mt-auto pt-2 border-top d-flex align-items-center justify-content-between"
              >
                <!-- Priority Indicator -->
                <div class="d-flex flex-column">
                  <span class="fs-11 text-muted">Priority</span>
                  <span class="d-inline-flex align-items-center fs-12">
                    <span
                      class="rounded-circle d-flex justify-content-center align-items-center me-1"
                      :class="{
                        'bg-transparent-danger': proj.priority === 'High',
                        'bg-transparent-warning': proj.priority === 'Medium',
                        'bg-transparent-success': proj.priority === 'Low',
                      }"
                    >
                      <i
                        class="ti ti-point-filled"
                        :class="{
                          'text-danger': proj.priority === 'High',
                          'text-warning': proj.priority === 'Medium',
                          'text-success': proj.priority === 'Low',
                        }"
                      ></i>
                    </span>
                    {{ proj.priority || "Medium" }}
                  </span>
                </div>

                <!-- Status Badge -->
                <div class="text-end">
                  <span class="fs-11 text-muted d-block">Status</span>
                  <span
                    class="badge badge-xs d-inline-flex align-items-center"
                    :class="[
                      'badge',
                      proj.status === 'Active'
                        ? 'badge-success'
                        : proj.status === 'Inactive'
                        ? 'badge-secondary'
                        : 'badge-warning',
                    ]"
                  >
                    <i class="ti ti-point-filled me-1"></i>
                    {{ proj.status || "Active" }}
                  </span>
                </div>
              </div>

              <!-- View Details Button -->
              <router-link
                :to="`/projects/projects-details/${proj.id}`"
                class="btn btn-sm btn-outline-primary w-100 mt-3 d-flex align-items-center justify-content-center"
              >
                <i class="ti ti-arrow-up-right me-1"></i>
                View Details
              </router-link>
            </div>
          </div>
        </div>

        <!-- Load More Button -->
        <div class="col-md-12" v-if="hasMore && projects.length">
          <div class="text-center mb-4">
            <button
              class="btn btn-primary"
              :disabled="store.loading"
              @click="loadMore"
            >
              <i class="ti ti-loader-3 me-1"></i>
              <span v-if="!store.loading">Load More</span>
              <span v-else>Loading...</span>
            </button>
          </div>
        </div>
      </div>
      <!-- End Project Grid -->
    </div>

    <!-- Footer -->
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>

  <!-- Modals -->
  <project-grid-modal ref="projectModal"></project-grid-modal>
  <project-details-modal ref="detailsModal"></project-details-modal>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useProjectStore } from "@/stores/projectStore";
import ProjectGridModal from "@/components/modal/project-grid-modal.vue";
import ProjectDetailsModal from "@/components/modal/project-details-modal.vue";
import { Modal } from "bootstrap";
import { useAuthStore } from "@/stores/authStore";

const auth = useAuthStore();
const isEmployee = computed(() => auth.roles?.includes("Employee"));

// Constants for breadcrumb
const title = "Projects";
const text = "Employee";
const text1 = "Projects Grid";

// Store and modal references
const store = useProjectStore();
const projectModal = ref(null);
const detailsModal = ref(null);

// Computed properties
const projects = computed(() => store.items);
const hasMore = computed(
  () => projects.value.length < (store.meta?.total || 0)
);

// Reactive state
const sortDisplay = ref("Recently Added");
let searchTimer = null;

/**
 * Computed property for status filter label
 */
const statusLabel = computed(() => {
  if (!store.filters.status) return "All";
  return store.filters.status;
});

/**
 * Sets priority filter and reloads projects
 * @param {string} v - Priority value ('High', 'Medium', 'Low', or '')
 */
function setPriority(v) {
  store.filters.priority = v;
  store.filters.page = 1;
  store.list();
}

/**
 * Debounced search function to prevent excessive API calls
 */
function debouncedReload() {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    store.filters.page = 1;
    store.list();
  }, 250);
}

/**
 * Toggles header collapse state
 */
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

/**
 * Formats date to a readable format
 * @param {string} v - Date string
 * @returns {string} Formatted date
 */
function formatDateFancy(v) {
  if (!v) return "—";
  let d = new Date(v);

  // Handle date parsing issues
  if (isNaN(d)) {
    const short = String(v).slice(0, 10);
    const parts = short.split("-");
    if (parts.length === 3) {
      const [y, m, day] = parts;
      d = new Date(`${y}-${m}-${day}T00:00:00Z`);
    }
  }

  if (isNaN(d)) return String(v);

  return d.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/**
 * Converts date to YYYY-MM-DD format
 * @param {Date|string} d - Date to convert
 * @returns {string} Formatted date string
 */
function toYMD(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (isNaN(dt)) return String(d).slice(0, 10);
  return dt.toISOString().slice(0, 10);
}

/**
 * Sets status filter and reloads projects
 * @param {string} v - Status value ('Active', 'Inactive', or '')
 */
function setStatus(v) {
  store.filters.status = v;
  store.filters.page = 1;
  store.list();
}

/**
 * Clears date range filters
 */
function clearDateFilters() {
  store.filters.date_from = "";
  store.filters.date_to = "";
}

/**
 * Applies sorting and reloads projects
 * @param {string} mode - Sort mode ('recent', 'asc', 'desc')
 */
function applySort(mode) {
  clearDateFilters();
  store.filters.sort = mode;
  store.filters.page = 1;

  // Update display text
  if (mode === "asc") sortDisplay.value = "Ascending";
  else if (mode === "desc") sortDisplay.value = "Descending";
  else sortDisplay.value = "Recently Added";

  store.list();
}

/**
 * Applies date filter for last 7 days
 */
function applyLast7Days() {
  const today = new Date();
  const from = new Date(today);
  from.setDate(from.getDate() - 7);

  store.filters.date_from = toYMD(from);
  store.filters.date_to = toYMD(today);
  store.filters.sort = "recent";
  store.filters.page = 1;
  sortDisplay.value = "Last 7 Days";
  store.list();
}

/**
 * Applies date filter for last month
 */
function applyLastMonth() {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const last = new Date(now.getFullYear(), now.getMonth(), 0);

  store.filters.date_from = toYMD(first);
  store.filters.date_to = toYMD(last);
  store.filters.sort = "recent";
  store.filters.page = 1;
  sortDisplay.value = "Last Month";
  store.list();
}

/**
 * Opens modal for creating a new project
 */
function openCreate() {
  projectModal.value?.openForCreate();
}

/**
 * Opens quick view modal for a project
 * @param {Object} rec - Project record
 */
function onView(rec) {
  detailsModal.value?.open(rec.id);
}

/**
 * Opens modal for editing a project
 * @param {Object} rec - Project record
 */
async function onEdit(rec) {
  const el = document.getElementById("add_project");
  if (el) new Modal(el, { backdrop: "static", keyboard: false }).show();

  try {
    await projectModal.value?.openForEdit(rec.id);
  } catch (e) {
    const inst = Modal.getInstance(el);
    inst?.hide();
  }
}

/**
 * Opens modal for deleting a project
 * @param {Object} rec - Project record
 */
async function onDelete(rec) {
  projectModal.value?.openForDelete(rec.id);
  const el = document.getElementById("delete_project");
  if (el) {
    new Modal(el, { backdrop: "static", keyboard: false }).show();
  }
}

/**
 * Loads more projects (pagination)
 */
async function loadMore() {
  if (!hasMore.value) return;
  const nextPage = (store.meta?.current_page || 1) + 1;
  await store.list({ page: nextPage, append: true });
}

function exportAs(format) {
  store.downloadReport(format);
}

/**
 * Lifecycle hook - loads projects on component mount
 */

onMounted(() => {
  if (isEmployee.value) store.filters.scope = "me";

  store.filters.page = 1; // always start grid from page 1
  store.list();
});
</script>


